<template>
    <div class="historical-overlay">
        <div class="historical-overlay-body">
            <div class="historical-overlay-title">
                <i class="pi pi-chart-bar historical-overlay-icon"/>
                <div class="historical-overlay-title-text">
                    {{ $t('AppHistoricalMapOverlay.Resumo do período') }}
                    <span v-if="subtitle" class="historical-overlay-subtitle">{{ subtitle }}</span>
                </div>
            </div>

            <div v-for="card in cards" :key="card.title" class="historical-overlay-row" :title="card.tooltip">
                <div>{{ card.title }}:</div>
                <div class="historical-overlay-value">{{ card.value }}</div>
            </div>

            <div v-if="cards.length === 0" class="historical-overlay-row">
                <div>{{ $t('AppHistoricalMapOverlay.Sem dados no período') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cards: {
                type: Array,
                default: () => []
            },
            subtitle: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped>

.historical-overlay {
    margin: 15px 0 0 15px;
}

.historical-overlay-body {
    pointer-events: auto;
    width: 330px;
    padding: 15px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    color: white;
}

.historical-overlay-title {
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 5px;
    display: inline-flex;
}

.historical-overlay-title-text {
    position: relative;
    bottom: 5px;
    left: 10px;
}

.historical-overlay-subtitle {
    font-size: 13px;
    font-weight: normal;
    opacity: 0.8;
    margin-left: 6px;
}

.historical-overlay-icon {
    font-size: 14px !important;
    position: relative;
    top: 1px;
}

.historical-overlay-row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    font-size: 14px;
}

.historical-overlay-value {
    font-weight: bold;
    margin: 3px 0;
    white-space: nowrap;
}

</style>
